export default "__VITE_ASSET__BhwDFkEn__"